// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2JZaI","imageUploader":"EGiftCard_imageUploader__34ojO"};